import React from 'react';
import { Dropdown } from '../../../Dropdown';
import { MenuVerticalFilled } from '../../../Icon';
import { Menu } from '../../../Menu';
import { Typography } from '../../../Typography';
import { ActionMenuItem } from '../../styled';
import { RowActionType } from '../../Table.decl';
import { InlineActionsList } from './InlineActionsList';
import { StyledRowIconButton } from './styled';

var InlineActions = function InlineActions(_ref) {
  var data = _ref.data,
      actionsType = _ref.actionsType,
      actions = _ref.actions;

  if (actionsType === RowActionType.Dropdown) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
      onVisibilityChange: function onVisibilityChange(flyoutVisibility) {
        if (flyoutVisibility) {
          if (typeof actions === 'function') {
            actions(data);
          }
        }
      },
      trigger: /*#__PURE__*/React.createElement(StyledRowIconButton, {
        component: MenuVerticalFilled,
        discColor: "secondary.lighter",
        size: 18
      }),
      anchor: "end"
    }, typeof actions === 'function' ? actions(data) : /*#__PURE__*/React.createElement(Menu, null, actions.map(function (action, index) {
      var ActionRenderer = action.renderer;
      return ActionRenderer ? /*#__PURE__*/React.createElement(ActionRenderer, {
        key: index,
        rowData: data
      }) : /*#__PURE__*/React.createElement(ActionMenuItem, {
        key: action.label,
        onClick: function onClick() {
          return action.onExecute(data);
        }
      }, /*#__PURE__*/React.createElement(Typography, null, action.label));
    }))));
  } else if (typeof actions === 'function') {
    return actions(data);
  }

  return /*#__PURE__*/React.createElement(InlineActionsList, {
    actions: actions,
    rowData: data
  });
};

export { InlineActions };